import { FormInstance } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectId, ProjectConversationId, UserType } from 'api/models';
import { Project } from 'api/project';
import { Form } from 'components/atoms/form';
import { useProjectSquad } from 'components/molecules/squad-picker/use-squad-options';
import { useActiveProjectConversation } from '../../../proj-conversation-hooks';
import { UserSelect } from './user-select';

export const InviteUserInput: FC<{
  project: Project;
  form: FormInstance;
}> = ({ project }) => {
  const activeConversation = useActiveProjectConversation();
  const { data: projectSquad, isLoading: isUsersLoading } = useProjectSquad(
    ProjectId(project.projectId),
  );

  const allUsers = !isUsersLoading
    ? [...projectSquad.users, ...projectSquad.notInProject]
    : [];
  const currentMembers = activeConversation?.members
    ? activeConversation.members.map((member) => member.user.userId)
    : [];

  const nonMembers = allUsers.filter(
    (user) => !currentMembers.includes(user.userId),
  );

  const filteredNonMembers = activeConversation?.private
    ? nonMembers.filter((user) => user.userType === UserType.Native)
    : nonMembers;

  return (
    <Form.Item
      name="nativeMembers"
      extra={<FormattedMessage id="projects.conversations.members.add_help" />}
    >
      {activeConversation && (
        <UserSelect
          options={filteredNonMembers}
          projectId={ProjectId(project.projectId)}
          conversationId={ProjectConversationId(
            activeConversation?.conversationId,
          )}
        />
      )}
    </Form.Item>
  );
};
